import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet-async'
import PageLayout from 'layouts/PageLayout'
import { DesktopScreen, MobileScreen } from 'utils/screen'
import { orderToTotalUnitPrice } from 'pages/order/modules/order'
import events from 'const/analytics-events'
import { withAnalyticsHandler } from 'enhancers/withAnalytics'

import { WhiteLabelMobile } from './Mobile'
import MenuModal from './MenuModal'
import WhiteLabelDesktop from './Desktop/WhiteLabelDesktop'
import WhiteLabelVenueStatus from 'common/WhiteLabelVenueStatus'

const VendorHelmet = ({ name, phone, address, allTags = [] }) => {
  if (!name) return null
  return (
    <Helmet encodeSpecialCharacters={false}>
      <title>{name && `${name} Food Takeaway | Menu`}</title>
      <script type="application/ld+json">{`
        {
          "@context" : "http://schema.org",
          "@type" : "Restaurant",
          "name" : "${name}",
          "telephone" : "${phone || ''}",
          "address" : {
            "@type" : "PostalAddress",
            "streetAddress" : "${address ? address.address1 || '' : ''}",
            "addressLocality" : "${address ? address.suburb || '' : ''}",
            "addressRegion" : "${address ? address.state || '' : ''}",
            "postalCode" : "${address ? address.postcode || '' : ''}"
          },
          "servesCuisine" : "${Array.isArray(allTags) &&
            allTags.map(tag => tag.name).join(' • ')}"
        }
      `}</script>
    </Helmet>
  )
}

class WhiteLabelVendorView extends React.Component {
  state = {
    isOpen: false,
    menu: {},
  }

  openModal = menu => {
    this.props.trackEvent({
      ...events['MENU_CLICK_ITEM'],
      label: String(this.props.info.id),
    })

    this.setState({
      isOpen: true,
      menu,
    })
  }

  closeModal = () => {
    this.setState({
      isOpen: false,
      menu: {},
    })
  }

  addOrder = order => {
    const {
      info: { id },
    } = this.props

    this.props.trackEvent({
      ...events['MENU_CLICK_ADD_TO_ORDER'],
      label: String(id),
    })

    this.props.addOrder(id, order)
  }

  render() {
    const { isOpen, menu } = this.state
    const { info, isLoading, order } = this.props

    const selectedOrders = order ? order.orders : []
    const orderQuantity = selectedOrders.reduce(
      (acc, curr) => acc + curr.quantity,
      0,
    )
    const orderPrice = selectedOrders.reduce(
      (total, currOrder) => total + orderToTotalUnitPrice(currOrder),
      0,
    )
    return (
      <PageLayout isLoading={isLoading}>
        <VendorHelmet {...info} />
        <WhiteLabelVenueStatus />

        <DesktopScreen>
          <WhiteLabelDesktop
            orderQuantity={orderQuantity}
            orderPrice={orderPrice}
            info={info}
            isLoading={isLoading}
            openModal={this.openModal}
          />
        </DesktopScreen>

        <MobileScreen>
          <WhiteLabelMobile
            orderQuantity={orderQuantity}
            orderPrice={orderPrice}
            info={info}
            selectedOrders={selectedOrders}
            openModal={this.openModal}
          />
        </MobileScreen>

        <MenuModal
          isOpen={isOpen}
          close={this.closeModal}
          action={this.addOrder}
          menu={menu}
        />
      </PageLayout>
    )
  }
}

WhiteLabelVendorView.propTypes = {
  location: PropTypes.object,
  order: PropTypes.object,
  venueId: PropTypes.number,
  history: PropTypes.object,
  addOrder: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  info: PropTypes.object,
  actions: PropTypes.object,
}

export const BaseVendorView = WhiteLabelVendorView
export default withAnalyticsHandler(WhiteLabelVendorView)
